import BreadCrumb from "../../src/components/Shared/BreadCrumb";
import Form from "../../src/components/Shared/Form";
import Contact from "../../src/components/Home/Contact";
import { Col, Container, Row } from "react-bootstrap";
import Link from "next/link";
import Image from "next/image";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import SwiperCore, { Pagination, Autoplay, EffectFade } from "swiper";
SwiperCore.use([Pagination, Autoplay, EffectFade]);

import Faqs from "../../src/components/Shared/Faqs";
import server from "../../src/api/server";
import { useIntl } from "react-intl";
import { NextSeo } from "next-seo";
const SingleService = ({
  serviceData,
  allServicesData,
  socialsData,
  error,
  breadBackground,
  contactUsBack,
  metaDataSections,
}) => {
  const { locale, formatMessage } = useIntl();
  const service = serviceData;
  const singleMeta = metaDataSections?.find(
    (item) => item?.slug === "services"
  );
  const neededInfo = socialsData?.filter((link) =>
    ["phone", "email", "location address", "location address_en"]?.includes(
      link?.socialType?.name?.en
    )
  );

  const renderServicesList = allServicesData?.map((item, index) => {
    if (item?.slug == service?.slug) return;
    else
      return (
        <li key={item?.slug}>
          <Link href={`/services/${item.slug}`}>
            <a aria-label="servicess">
              <span>.0{index + 1}</span>
              {item?.name?.[locale]}
            </a>
          </Link>
        </li>
      );
  });

  const renderImages = service?.images?.map((item, index) => {
    return (
      <SwiperSlide key={"itemImage" + index}>
        <div className="img-holder ">
          <Image
            src={`${process.env.NEXT_PUBLIC_MAIN_URL}${item}`}
            width={810}
            height={400}
            alt=""
          />
        </div>
      </SwiperSlide>
    );
  });

  return (
    <>
      <NextSeo
        title={service?.meta?.title[locale] || service?.name[locale]}
        description={
          service?.meta?.description[locale] || service?.description[locale]
        }
        additionalMetaTags={[
          {
            name: "keywords",
            content: "",
          },
          {
            name: "description",
            content: "",
          },
        ]}
      />
      <div className="single-service">
        <BreadCrumb
          title={service?.name?.[locale]}
          pageTitle={service?.name?.[locale]}
          breadBackground={breadBackground}
        />
        <div className="single-service-body">
          <Container>
            <Row>
              <Col xl={12} lg={12} md={12} xs={12}>
                <div className="service-content">
                  <div
                    className="service-slider"
                    data-aos="fade-up"
                    data-aos-duration="300"
                    data-aos-delay="100"
                  >
                    <Swiper
                      dir={locale}
                      loop={false}
                      slidesPerView={1}
                      centeredSlides={false}
                      effect={"fade"}
                      pagination={true}
                      autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                      }}
                      className="mySwiper"
                    >
                      {renderImages}
                    </Swiper>
                  </div>
                  <h3
                    data-aos="fade-up"
                    data-aos-duration="300"
                    data-aos-delay="200"
                  >
                    {service?.name?.[locale]}
                  </h3>
                  <div
                    data-aos="fade-up"
                    data-aos-duration="300"
                    data-aos-delay="300"
                    className="services-desc "
                    style={{ fontSize: "20px", textAlign: "justify" }}
                    dangerouslySetInnerHTML={{
                      __html: service?.description?.[locale],
                    }}
                  ></div>
                </div>
                <Faqs faqs={service?.faqs} />
              </Col>
            </Row>
          </Container>
        </div>
        <Form
          formSubtitle={formatMessage({ id: "askService" })}
          formTitle={formatMessage({ id: "toAskService" })}
        />
        <Contact
          {...{
            socialsData,
            contactUsBack,
          }}
        />
      </div>
    </>
  );
};
export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking", // false or 'blocking'
  };
}

export const getStaticProps = async (ctx) => {
  try {
    const { id } = ctx.params;
    const serviceResponse = await server.get(`/pages/services/sections/${id}`);
    const allServicesResponse = await server.get(`/pages/services`);
    const socialsResponse = await server.get("/settings/socials");
    const metaResponse = await server.get("/pages/metaData");
    let breadBack, contactUsBack;
    try {
      const backgroundResponse = await server.get("/pages/backgrounds");
      breadBack = backgroundResponse?.data?.data?.page?.sections?.find(
        (sec) => sec?.slug === "breadcrumbs"
      )?.image;
      contactUsBack = backgroundResponse?.data?.data?.page?.sections?.find(
        (sec) => sec?.slug === "contactUs"
      )?.image;
    } catch (err) {
      console.log(err);
    }

    return {
      revalidate: 1,
      props: {
        serviceData: serviceResponse?.data?.data?.section,
        allServicesData: allServicesResponse?.data?.data?.page.sections,
        socialsData: socialsResponse?.data?.data?.socials,
        metaDataSections: metaResponse?.data?.data?.page?.sections,
        breadBackground: breadBack
          ? `${process.env.NEXT_PUBLIC_MAIN_URL}/${breadBack}`
          : null,
        contactUsBack: contactUsBack
          ? `${process.env.NEXT_PUBLIC_MAIN_URL}/${contactUsBack}`
          : null,
      },
    };
  } catch (error) {
    return {
      revalidate: 1,
      props: {
        error: JSON.stringify(error),
      },
    };
  }
};

export default SingleService;
